var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedroomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83594 13.8307V8.4974C1.83594 8.14377 1.97641 7.80464 2.22646 7.55459C2.47651 7.30454 2.81565 7.16406 3.16927 7.16406H13.8359C14.1896 7.16406 14.5287 7.30454 14.7787 7.55459C15.0288 7.80464 15.1693 8.14377 15.1693 8.4974V13.8307",
    stroke: "#FF5A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16406 7.16406V4.4974C3.16406 4.14377 3.30454 3.80464 3.55459 3.55459C3.80464 3.30454 4.14377 3.16406 4.4974 3.16406H12.4974C12.851 3.16406 13.1902 3.30454 13.4402 3.55459C13.6903 3.80464 13.8307 4.14377 13.8307 4.4974V7.16406",
    stroke: "#FF5A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.16406V7.16406",
    stroke: "#FF5A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83594 12.5H15.1693",
    stroke: "#FF5A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroomIcon);
export default __webpack_public_path__ + "static/media/bedroom-icon.31482714aca3702cd300c76be9030431.svg";
export { ForwardRef as ReactComponent };